// 获取模块主要获取数据模块
import request from '@/utils/request';
// 添加金币充值
export const addList = (data) => request({url: '/look/rechargeManagement/addRechargeManagement', method: 'post', data});
// 修改金币充值
export const editList = (data) => request({url: '/look/rechargeManagement/updateRechargeManagement', method: 'put', data});
// 用户管理-修改用户金币总数量
export const editGlodTotalNumber = (data) => request({url: '/look/userManagement/updateUserMoneyById', method: 'put', data});
// 获取数据
export const getData = () => request({url: '/look/rechargeManagement/getAllRechargeManagement', method: 'get'});
// 获取回显数据
export const getEcho = (id) => request({url: `/look/rechargeManagement/getRechargeManagement?id=${id}`, method: 'get'});
// 删除数据
export const deleteData = (data) => request({url: '/look/rechargeManagement/deleteRechargeManagement', method: 'delete', data});
// 获取充值记录数据
export const getList = (current, size, endDate, startDate) => request({url: `/look/rechargeManagement/getRechargeRecord?current=${current}&size=${size}&endDate=${endDate}&startDate=${startDate}`, method: 'get'});
